import { DiscountsApiFactory } from '@mynt/backoffice-api-spec/discounts'
import Axios from 'api/axios'
import config from 'config'
import type { CustomerPlanDiscount } from './api'
import { mapCreateFlatAndPerUnitDiscountToCreateDiscountRequest, mapCustomerDiscountsToPlanDiscount } from './mappers'

const discountApi = DiscountsApiFactory(undefined, config.boBaseUrl, Axios)

export const getPlanDiscount = (customerId: string) => {
  return discountApi.getCustomerDiscounts(customerId).then(({ data }) => mapCustomerDiscountsToPlanDiscount(data))
}

export const createPlanDiscount = (customerId: string, flatAndPerUnitDiscount: CustomerPlanDiscount) => {
  return discountApi.createPlanDiscount(customerId, mapCreateFlatAndPerUnitDiscountToCreateDiscountRequest(flatAndPerUnitDiscount))
}

export const deleteDiscount = (customerId: string) => {
  return discountApi.deletePlanDiscount(customerId)
}
